import { create } from 'zustand';

type LicenseState = {
  licenseKey: string | null;
  valid: boolean;
  setKey: (key: string) => void;
  validateAndSave: (key: string) => boolean;
};

function dummyValidate(key: string): boolean {
  // Example: EVAT-XXXX... with length >= 10
  return key.length >= 10 && key.includes('-');
}

const STORAGE_KEY = 'evat_license_key';

export const useLicenseStore = create<LicenseState>((set) => {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  const initialValid = stored ? dummyValidate(stored) : false;
  return {
    licenseKey: stored,
    valid: initialValid,
    setKey: (key: string) => set({ licenseKey: key, valid: dummyValidate(key) }),
    validateAndSave: (key: string) => {
      const ok = dummyValidate(key);
      if (ok) {
        localStorage.setItem(STORAGE_KEY, key);
      }
      set({ licenseKey: key, valid: ok });
      return ok;
    }
  };
});



















